/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { OktaAuthOptions } from '@okta/okta-auth-js';

export type OktaConfig = {
  oidc: OktaAuthOptions;
  resourceServer: {
    messagesUrl: string;
  };
  app: {
    basename: string;
  };
};

export function getOktaConfig(clientId: string, baseDomain: string, customDomain: string): OktaConfig {
  const issuer = `https://${baseDomain}/oauth2/default`;
  const baseName = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.PUBLIC_URL;
  const redirectUri = `${baseName}/login/callback`;
  const customPrefix = `https://${customDomain}/oauth2/default/v1`;
  const authorizeUrl = `${customPrefix}/authorize`;
  const userinfoUrl = `${customPrefix}/userinfo`;
  const tokenUrl = `${customPrefix}/token`;
  const revokeUrl = `${customPrefix}/revoke`;
  const logoutUrl = `${customPrefix}/logout`;
  return {
    oidc: {
      clientId,
      issuer,
      redirectUri,
      authorizeUrl,
      userinfoUrl,
      tokenUrl,
      revokeUrl,
      logoutUrl,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      pkce: true,
    },
    resourceServer: {
      messagesUrl: 'http://localhost:8000/api/messages',
    },
    app: {
      basename: baseName,
    },
  };
}
